import { Inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { AuthService } from '../services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(
    private authService: AuthService,
    private router: Router
  ) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {

    if (this.authService.isAuthenticated()) {
      let role: string = this.authService.getCurrentUser()?.['role'] || '';
      const routeRole = route.data['role'];

      if (role) {
        if (role == "admin" && (routeRole == "ROLE_CLIENT" || routeRole == "ROLE_ACCOUNTING")) {
          this.router.navigate(['/admin']);
          return false;
        }

        if (role == "client" && (routeRole == "ROLE_ADMIN" || routeRole == "ROLE_ACCOUNTING")) {
          this.router.navigate(['/client']);
          return false;
        }

        if (role === "manager" && (routeRole == "ROLE_ADMIN" || routeRole == "ROLE_CLIENT")) {
          this.router.navigate(['/accounting']);
          return false;
        }
      }

      return true;
    } else {

      // Save the attempted URL so we can redirect after login
      this.authService.redirectUrl = state.url;

      this.router.navigate(['/login']);
      return false;
    }
  }
}

@Injectable({
  providedIn: 'root'
})
export class RoleGuard implements CanActivate {
  constructor(
    private authService: AuthService,
    private router: Router
  ) { }

  canActivate(): boolean {
    const user = this.authService.getCurrentUser();
    if (user) {
      return true;
    } else {
      this.router.navigate(['/login']);
      return false;
    }
  }
}